import React, { Component } from "react";
import { Container, Dropdown, Segment, Card, Header } from "semantic-ui-react";

import * as CONSTANTS from "../assets/Constants";
import * as LINKS from "../assets/Links";
import MemberProfile from "./MemberProfile";

class BatchesList extends Component {
  constructor(props) {
    super(props);
    this.handleSelectedBatch = this.handleSelectedBatch.bind(this);
  }

  state = {
    batchesToBeRendered: [],
    membersToBeRendered: [],
    responsiveCount: 4
  };

  handleSelectedBatch = (event, selected) => {
    let year = selected.value;
    // console.log(year);
    // eslint-disable-next-line eqeqeq
    if (year == "") {
      this.setState({ membersToBeRendered: [] });
      return;
    }
    let membersList = [];
    fetch(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.teamDetailsByYear + year)
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        // let membersPanesLocal = [];
        // membersPanesLocal.push({ menuItem: "Members", icon: "arrow down" });
        Object.keys(data).forEach(function(key, index) {
          let each = data[key];
          console.log(each.id + ", " + each.name);
          membersList.push(
            <MemberProfile key={each.id} data={each} type="CARD" />
          );
        });
        this.setState({ membersToBeRendered: membersList });
      })
      .catch(error => {
        console.log(error);
      });
  };

  componentWillMount() {
    let batchesList = CONSTANTS.batchesList;
    var batchesLocal = [];
    batchesList.forEach(function(year) {
      batchesLocal.push({
        key: year,
        text: year,
        value: year
      });
    });
    this.setState({ batchesToBeRendered: batchesLocal });
    if (window.innerWidth / 100 < 5) {
      this.setState({ responsiveCount: 1 });
    } else if (window.innerWidth / 100 < 8) {
      this.setState({ responsiveCount: 3 });
    } else {
      this.setState({ responsiveCount: 4 });
    }
  }

  render() {
    return (
      <Container
        textAlign="center"
        style={{
          padding: "1em 0em"
        }}
      >
        <Header textAlign="center" style={{ marginTop: "1em" }} as="h2">
          <Header.Subheader style={{ fontSize: "0.7em" }}>
            <strong>Profiles of RCS Members</strong>
          </Header.Subheader>
          <Header.Subheader style={{ fontSize: "0.5em" }}>
            Select a batch from the Dropdown and click on a card to see more details.
          </Header.Subheader>
        </Header>
        <Dropdown
          clearable
          options={this.state.batchesToBeRendered}
          selection
          placeholder="Choose a batch"
          onChange={this.handleSelectedBatch}
          // defaultValue={this.state.batchesToBeRendered[2].value}
        />
        <Segment style={{ minHeight: 400, margin: "1em" }} raised={true}>
          <Card.Group centered itemsPerRow={this.state.responsiveCount}>
            {this.state.membersToBeRendered}
          </Card.Group>
        </Segment>
      </Container>
    );
  }
}

export default BatchesList;
